'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _users = require('redux/modules/users');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserInviteForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.users.user,
    image: state.users.image,
    loaded: state.users.loaded,
    saving: state.users.saving,
    saveError: state.users.saveError
  };
}, { invite: _users.invite }, null, { withRef: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(UserInviteForm, _Component);

  function UserInviteForm() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UserInviteForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UserInviteForm.__proto__ || (0, _getPrototypeOf2.default)(UserInviteForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      user: {
        role: 'contributor',
        name: '',
        email: '',
        message: ''
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UserInviteForm, [{
    key: 'handleInvite',
    value: function handleInvite() {
      var _this2 = this;

      var _props = this.props,
          invite = _props.invite,
          selectedEntity = _props.selectedEntity,
          selectedType = _props.selectedType; // eslint-disable-line no-shadow

      var user = this.state.user;


      var query = (0, _extends3.default)({}, user);

      if (selectedType === 'calendar') {
        query.calendar_id = selectedEntity.id;
      } else if (selectedType === 'organization') {
        query.organization_id = selectedEntity.id;
      }

      invite(query).then(function (res) {
        if (res && res.type === _users.INVITE_SUCCESS) {
          _this2.handleCloseModal();
        }
      }).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: 'handleCloseModal',
    value: function handleCloseModal() {
      this.props.closeModal();
    }
  }, {
    key: 'changeUserRole',
    value: function changeUserRole(event) {
      this.setState({
        user: (0, _extends3.default)({}, this.state.user, {
          role: event.target.value
        })
      });
    }
  }, {
    key: 'changeUserEmail',
    value: function changeUserEmail(event) {
      this.setState({
        user: (0, _extends3.default)({}, this.state.user, {
          email: event.target.value
        })
      });
    }
  }, {
    key: 'changeUserName',
    value: function changeUserName(event) {
      this.setState({
        user: (0, _extends3.default)({}, this.state.user, {
          name: event.target.value
        })
      });
    }
  }, {
    key: 'changeInviteMessage',
    value: function changeInviteMessage(event) {
      this.setState({
        user: (0, _extends3.default)({}, this.state.user, {
          message: event.target.value
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          polyglot = _props2.polyglot,
          saving = _props2.saving,
          saveError = _props2.saveError,
          selectedEntity = _props2.selectedEntity,
          selectedType = _props2.selectedType;
      var user = this.state.user;

      var hasErrors = saveError && saveError[user.id];
      var errorMessage = hasErrors ? saveError[user.id].message : '';
      var errorFields = hasErrors ? saveError[user.id].errors : '';

      var context = selectedType === 'calendar' ? 'le calendrier ' + selectedEntity.name : 'l\'organisation ' + selectedEntity.name;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'modal-body' },
          _react2.default.createElement(
            'div',
            { className: 'user-invite-form' },
            _react2.default.createElement('button', {
              type: 'button',
              onClick: this.handleCloseModal.bind(this),
              className: 'close-modal-button icon-cg-close'
            }),
            _react2.default.createElement(
              'h4',
              null,
              polyglot.t('users.invite.text'),
              ' ',
              context
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement('input', {
                type: 'text',
                id: 'user-name-box',
                className: 'form-control' + (errorFields && errorFields.name ? ' has-error' : ''),
                onChange: this.changeUserName.bind(this),
                defaultValue: user.name,
                autoFocus: true,
                placeholder: polyglot.t('users.titleBox.help')
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement('input', {
                type: 'email',
                id: 'user-email-box',
                onChange: this.changeUserEmail.bind(this),
                className: 'form-control' + (errorFields && errorFields.email ? ' has-error' : ''),
                defaultValue: user.email,
                placeholder: polyglot.t('users.attributes.email')
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'select',
                { className: 'form-control', defaultValue: this.state.user.role, onChange: this.changeUserRole.bind(this) },
                _react2.default.createElement(
                  'option',
                  { value: 'guest' },
                  polyglot.t('roles.guest')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'contributor' },
                  polyglot.t('roles.contributor')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'editor' },
                  polyglot.t('roles.editor')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'admin' },
                  polyglot.t('roles.admin')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement('textarea', {
                id: 'user-invite-message',
                defaultValue: user.message,
                placeholder: polyglot.t('users.invite.messagePlaceholder'),
                onChange: this.changeInviteMessage.bind(this),
                className: 'form-control' + (errorFields && errorFields.message ? ' has-error' : '')
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal-footer' },
          _react2.default.createElement(
            'div',
            { className: 'pull-right' },
            _react2.default.createElement(
              'span',
              { className: 'status-label label label-danger' },
              errorMessage
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'btn btn-primary',
                onClick: !saving ? this.handleInvite.bind(this) : null,
                disabled: saving
              },
              saving ? _react2.default.createElement('i', { className: 'glyphicon glyphicon-refresh cg-spinner' }) : '',
              ' ',
              polyglot.t('users.invite.save')
            )
          )
        )
      );
    }
  }]);
  return UserInviteForm;
}(_react.Component), _class2.propTypes = {
  closeModal: _propTypes2.default.func,
  invite: _propTypes2.default.func.isRequired,
  polyglot: _propTypes2.default.object.isRequired,
  saving: _propTypes2.default.bool,
  saveError: _propTypes2.default.object,
  selectedEntity: _propTypes2.default.object.isRequired,
  selectedType: _propTypes2.default.string.isRequired
}, _temp2)) || _class);
exports.default = UserInviteForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/User/UserInviteForm.js
// module id = 2249
// module chunks = 0